import { Component, OnInit, inject } from '@angular/core';
import { SidemenuComponent } from './components/sidemenu/sidemenu.component';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { TegelModule } from '@scania/tegel-angular-17';
import { StartupService } from './services/startup.service';
import { PageBannerComponent } from "./components/header/page-banner/page-banner.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [SidemenuComponent, RouterOutlet, HeaderComponent, FooterComponent, TegelModule, PageBannerComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
   private readonly startupService = inject(StartupService);

   async ngOnInit() {
    await this.startupService.initializeServices();
  }
}

